import type { ColDef } from 'ag-grid-community'

export type BuildColDef<TData, SharedProps> = Omit<ColDef<TData>, 'cellRenderer'> & {
  cellRenderer?: (
    params: { data?: TData; value?: unknown },
    shared: SharedProps
  ) => unknown
}

export function createColumnCtx<SharedProps>(props: SharedProps) {
  return function buildColumns<TData = unknown>(
    defs: BuildColDef<TData, SharedProps>[]
  ): ColDef<TData>[] {
    return defs.map(({ cellRenderer, ...rest }) => ({
      ...rest,
      ...(cellRenderer
        ? {
            cellRenderer: (params: { data?: TData; value?: unknown }) =>
              cellRenderer(params, props)
          }
        : {}),
    }))
  }
}
